import { render, staticRenderFns } from "./SendList.vue?vue&type=template&id=2f2114c4"
import script from "./SendList.vue?vue&type=script&lang=js"
export * from "./SendList.vue?vue&type=script&lang=js"
import style0 from "./SendList.vue?vue&type=style&index=0&id=2f2114c4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports